module.exports = __webpack_public_path__ + "media/components/service_card/static/service-image-4123aa7b1339252d2d6bcbc369d3846a.png";